<template>

  <div class="pa-3">

    <h4 class="display-1">Service Area Overview</h4>

    <v-divider></v-divider>

    <v-container fluid>

      <v-layout>

        <v-flex>

          <div class="">

            <v-switch v-model="useWizardPreferences" label="Use Wizard Choices"></v-switch>

            <ServiceAreasTable
              color="transparent"
              :items="items"
              :hide-default-footer="false"
              :search="search"
              :dense="false"
              :sort-by="sortOptions.sort"
              :sort-desc="sortOptions.desc"

              show-filters

              @row-clicked="handleRowClick"
            >

            </ServiceAreasTable>

          </div>

        </v-flex>

        <v-flex grow>

          <v-card v-if="mapVisible" class="ml-2">

            <StandardMap ref="mapContainer"
                         :min-width="390"
                         :min-height="650"
                         :padding="[0, 200]"
            >

              <l-control position="topleft">
                <v-btn
                  small
                  color="grey lighten-3 primary--text"
                  :ripple="false"
                  depressed
                  @click="handleFeatureDeselect"
                  :disabled="!$route.query.service"
                >
                  <v-icon small left>mdi-close-circle</v-icon>
                  Clear Selection
                </v-btn>
              </l-control>

              <ServiceAreasLayer :display-labels="false"></ServiceAreasLayer>

              <SelectedFeatureLayer provider-link=""></SelectedFeatureLayer>

            </StandardMap>

          </v-card>

        </v-flex>

      </v-layout>

    </v-container>

  </div>

</template>

<script>
import ServiceAreasTable from '../components/tables/ServiceAreasTable';
import StandardMap from '../components/map-components/StandardMap';
import ServiceAreasLayer from '../components/map-components/ServiceAreasLayer';
import SelectedFeatureLayer from '../components/map-components/SelectedFeatureLayer';

export default {

  name: 'ServiceAreas',

  components: {
    ServiceAreasTable,
    StandardMap,
    ServiceAreasLayer,
    SelectedFeatureLayer,
  },

  data() {
    return {
      mapVisible: false,
      useWizardPreferences: false,
      search: '',
      sortOptions: {
        sort: this.$store.state.route.query.sort ? this.$store.state.route.query.sort : 'properties.Location',
        desc: this.$store.state.route.query.desc ? JSON.parse(this.$store.state.route.query.desc) : false,
      },
    };
  },

  mounted() {
    setTimeout(() => {
      this.mapVisible = true;
    }, 25);
  },

  computed: {

    items() {
      const data = this.useWizardPreferences ? this.$store.getters.filteredServiceAreas : this.serviceAreas;
      return data;
    },

    serviceAreas() {
      return this.$store.getters.serviceAreas;
    },

  },

  methods: {

    handleRowClick(feature) {
      this.$router.push({
        query: {
          ...this.$route.query,
          service: feature.id,
        },
      });
    },

    handleFeatureDeselect() {
      console.log('handleFeatureDeselect');
      const query = { ...this.$route.query };
      delete query.service;
      this.$router.push({
        query,
      });
    },

  },

};
</script>
